var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 15.5C1.3375 15.5 0.984375 15.3531 0.690625 15.0594C0.396875 14.7656 0.25 14.4125 0.25 14V3.5C0.25 3.0875 0.396875 2.73437 0.690625 2.44062C0.984375 2.14687 1.3375 2 1.75 2H2.5V0.5H4V2H10V0.5H11.5V2H12.25C12.6625 2 13.0156 2.14687 13.3094 2.44062C13.6031 2.73437 13.75 3.0875 13.75 3.5V14C13.75 14.4125 13.6031 14.7656 13.3094 15.0594C13.0156 15.3531 12.6625 15.5 12.25 15.5H1.75ZM1.75 14H12.25V6.5H1.75V14ZM1.75 5H12.25V3.5H1.75V5Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.d8b765b166200ddfd5839dad4491cb87.svg";
export { ForwardRef as ReactComponent };